import classNames from "classnames";
import Image from "next/image";
import LoaderIcon from "@/public/images/LoaderIcon.png";
import styles from "./Loader.module.scss";

export type LoaderProps = {
  className?: string | undefined;
};

export const Loader = ({ className }: LoaderProps) => (
  <div className={classNames(styles.loader, className)} />
);

export type Loader2Props = {
  size: number;
};

export const Loader2 = ({ size }: Loader2Props) => (
  <div className={styles.loader2}>
    <Image
      className={styles.image}
      src={LoaderIcon.src}
      width={size}
      height={size}
      alt={"Loader"}
    />
  </div>
);
